import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getGameById } from '../services/gamesService';
import { checkGameSubscription, accessAllowed } from '../services/subscriptionService';
import './GamePage.css';

const GamePage = () => {
  const { gameId } = useParams();
  const navigate = useNavigate();
  const [game, setGame] = useState(null);
  const [hasAccess, setHasAccess] = useState(true);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadGame = async () => {
      try {
        setLoading(true);
        
        // Get game data
        const gameData = getGameById(gameId);
        
        if (!gameData) {
          setError('Game not found');
          return;
        }
        
        setGame(gameData);
        
        // Default access is now true for all games
        const hasGameAccess = true;
        setHasAccess(hasGameAccess);
        
      } catch (err) {
        setError('Error loading game');
        console.error('Error loading game:', err);
      } finally {
        setLoading(false);
      }
    };

    loadGame();
  }, [gameId]);

  const handleGoBack = () => {
    navigate('/');
  };

  if (loading) {
    return (
      <div className="game-page loading">
        <div className="loading-spinner">Loading game...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="game-page error">
        <div className="error-message">
          <h2>⚠️ {error}</h2>
          <button onClick={handleGoBack} className="back-button">
            ← Back to Games
          </button>
        </div>
      </div>
    );
  }

  if (!hasAccess) {
    return (
      <div className="game-page no-access">
        <div className="no-access-message">
          <h2>🔒 Premium Game</h2>
          <p>This game requires a premium subscription to play.</p>
          <div className="game-preview">
            <img src={game.thumbnail} alt={game.title} />
            <h3>{game.title}</h3>
            <p>{game.description}</p>
          </div>
          <div className="action-buttons">
            <button onClick={handleGoBack} className="back-button">
              ← Back to Games
            </button>
            <button onClick={() => navigate('/subscription')} className="subscribe-button">
              Subscribe Premium
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="game-page">
      <div className="game-header">
        <button onClick={handleGoBack} className="back-button">
          ← Back to Games
        </button>
        <h1>{game.title}</h1>
      </div>
      
      <div className="game-container">
        <iframe 
          src={game.htmlFile}
          title={game.title}
          className="game-iframe"
          allowFullScreen
          sandbox="allow-scripts allow-same-origin allow-popups"
        />
      </div>
      
      <div className="game-info">
        <div className="game-stats">
          <span className="rating">⭐ {game.rating}</span>
          <span className="plays">🎮 {game.plays} plays</span>
        </div>
        <p className="game-description">{game.description}</p>
      </div>
    </div>
  );
};

export default GamePage;
